import Grid from "@mui/material/Grid";
import { useContext } from "react";
import { useController } from "react-hook-form";
import { styled } from "@mui/material/styles";
import useEditor from "components/hooks/useEditor";
import { FormContext } from "components/shared/Form";
import BubbleMenu from "components/ui/atoms/Editor/BubbleMenu";
import EditorContent from "components/ui/atoms/Editor/EditorContent";
import FixedMenu from "components/ui/atoms/Editor/FixedMenu";

const StyledEditorContentContainer = styled(Grid)(
  ({ theme }) => `
  overflow: scroll;
  .tiptap p.is-editor-empty:first-of-type::before {
    color: ${theme.palette_custom.grey};
    content: attr(data-placeholder);
    float: left;
    height: 0;
    pointer-events: none;
    font-size: ${theme.fontSize.md};
  }
  .tiptap ul {
    margin: 0;
  }
  height: 300px; // arbitrary value from 13" screen
  overflow-y: scroll;
  width: 100%;
`,
);
const StyledFixedMenuContainer = styled(Grid)(
  ({ theme }) => `
  background-color: ${theme.palette_custom.white};
  width: 100%;
  border-bottom: 0.5px solid ${theme.palette_custom.darkBlue};
`,
);
const StyledEditorContainer = styled(Grid)(
  ({ theme }) => `
  border: 0.5px solid ${theme.palette_custom.darkBlue};
`,
);

const EditorField = ({ name }) => {
  const {
    form: { control },
  } = useContext(FormContext);

  const { field } = useController({
    name,
    control,
    rules: { required: true },
  });

  const { editor } = useEditor({
    html: field.value,
    onChange: field.onChange,
    onBlur: field.onBlur,
  });

  return (
    editor && (
      <StyledEditorContainer container>
        <StyledFixedMenuContainer>
          <FixedMenu editor={editor} />
        </StyledFixedMenuContainer>
        <StyledEditorContentContainer p={1}>
          <EditorContent editor={editor} />
        </StyledEditorContentContainer>
        <BubbleMenu editor={editor} />
      </StyledEditorContainer>
    )
  );
};

export default EditorField;
